const selectors = {
    getStepActualPosition: state => state.stepActualPosition,
}

export { selectors }